export const FETCH_CONTACTS = 'fetchContacts'
